import { DataFileCreationChain, DataFile } from "interfaces";

const getSourceData = (
  sourceData: string | string[] | { id: string }[]
): string[] => {
  if (typeof sourceData === "string") {
    return [sourceData];
  }

  return (sourceData as (string | { id: string })[]).map((d) =>
    typeof d === "string" ? d : d.id
  );
};

const createSteps = (
  chain: DataFileCreationChain | undefined,
  file: DataFile.DataFile | string
) => {
  if (!chain) {
    return [];
  }

  let steps: {
    index: number;
    transform: { type: string; files: string[] }[];
  }[] = [];

  const final = chain[typeof file === "string" ? file : file.id];
  if (!final) {
    return steps;
  }
  steps.push({
    index: 0,
    transform: [
      {
        type: final.create_type,
        files: getSourceData(final.create_spec.source_data),
      },
    ],
  });

  let ind = 1;
  while (true) {
    const lastStep = steps[ind - 1];

    let transform: { type: string; files: string[] }[] = [];
    lastStep.transform.forEach(({ files }) => {
      files
        .filter((f) => chain[f])
        .forEach((f) => {
          const m = chain[f];
          transform.push({
            type: m.create_type,
            files: getSourceData(m.create_spec.source_data),
          });
        });
    });

    if (transform.length >= 1) {
      steps.push({ index: ind, transform: transform });
      ind += 1;
    } else {
      break;
    }
  }

  return steps;
};

export default createSteps;
